/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OpProcedureOrder from './op-procedure-order';
import OpProcedureOrderDetail from './op-procedure-order-detail';
import OpProcedureOrderUpdate from './op-procedure-order-update';
import OpProcedureOrderDeleteDialog from './op-procedure-order-delete-dialog';

const OpProcedureOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OpProcedureOrder />} />
    <Route path="new" element={<OpProcedureOrderUpdate />} />
    <Route path=":id">
      <Route index element={<OpProcedureOrderDetail />} />
      <Route path="edit" element={<OpProcedureOrderUpdate />} />
      <Route path="delete" element={<OpProcedureOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OpProcedureOrderRoutes;
